import {MessageCodes} from "../MessageCodes";
import ResultHeader from "../../Table/ResultHeader";
import ResultRow from "../../Table/ResultRow";
import ResultBody from "../../Table/ResultBody";
import ResultBodyCell from "../../Table/ResultBodyCell";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import ResultTable from "../../Table/ResultTable";
import ResultCellHighlight from "../../Table/ResultCellHighlight";
import EmptyLine from "../../EmptyLine";
import ResultText from "../ResultText";
import HecRasHelper from "../../../Helpers/HecRasHelper";
import ComparisonCSName from "../../ComparisonCSName";
import {useUser} from "../../../Context/UserContext";
import ResultView from "../../V2/ResultView";

export function C13({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const renderSections = (row) => {
    const components = []
    let has_error_perm = false

    row.data.forEach(x => {
        x.data.forEach(r => {
            has_error_perm = HecRasHelper.isUndefined(r.base_perm) !==  HecRasHelper.isUndefined(r.cmp_perm)
        })
    })
    
    row.data.forEach((x, idx) => {
        x.data.forEach((r, idy) => {
            components.push(
                <>
                    <ResultRow>
                        {
                            idy === 0 && (
                                <ResultBodyCell rowSpan={x.data.length} style={{textAlign: 'left', verticalAlign: 'bottom', width: 125}}>
                                    <ComparisonCSName csName={x.cross_section} />
                                </ResultBodyCell>
                            )
                        }
                        <ResultBodyCell style={{textAlign: 'right'}}>{HecRasHelper.isUndefined(r.base_start_sta)}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{HecRasHelper.isUndefined(r.base_end_sta)}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{HecRasHelper.isUndefined(r.base_elev)}</ResultBodyCell>
                        {has_error_perm && <ResultBodyCell style={{textAlign: 'right'}}>{HecRasHelper.isUndefined(r.base_perm)}</ResultBodyCell>}
                        <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(HecRasHelper.isUndefined(r.base_start_sta), HecRasHelper.isUndefined(r.cmp_start_sta))}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(HecRasHelper.isUndefined(r.base_end_sta),  HecRasHelper.isUndefined(r.cmp_end_sta))}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(HecRasHelper.isUndefined(r.base_elev),  HecRasHelper.isUndefined(r.cmp_elev))}</ResultBodyCell>
                        {has_error_perm && <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(HecRasHelper.isUndefined(r.base_perm),  HecRasHelper.isUndefined(r.cmp_perm))}</ResultBodyCell>}
                    </ResultRow>
                </>
            )
        })
    })
    return {
        components,
        has_error_perm
    }
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Compare.TIEFF001.error_id: {
            const render = renderSections(row);
            return (
                <>
                    <ResultText>
                        There are differences in the ineffective flow areas between {globalVariables?.sel_plan_title || 'base'} and {globalVariables?.tar_plan_title || 'comparison'} plan at the following {row.data.length} cross-sections:
                    </ResultText>
                    <ResultTable data={row}>
                        <ResultHeader>
                        <ResultRow>
                            <ResultHeaderCell rowSpan={3} style={{textAlign: 'left', verticalAlign: 'bottom'}}>River Station</ResultHeaderCell>
                            <ResultHeaderCell colSpan={render.has_error_perm ? 8 : 6}>Ineffective Flow Areas</ResultHeaderCell>
                        </ResultRow>
                        <ResultRow>
                            <ResultHeaderCell colSpan={render.has_error_perm ? 4 : 3}>{globalVariables?.sel_plan_title || 'Base'}</ResultHeaderCell>
                            <ResultHeaderCell colSpan={render.has_error_perm ? 4 : 3}>{globalVariables?.tar_plan_title || 'Comparison'}</ResultHeaderCell>
                        </ResultRow>
                        <ResultRow>
                            <ResultHeaderCell style={{textAlign: 'right', width: 80}}>Start Sta</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'right', width: 80}}>End Sta</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'right', width: 80}}>Elev</ResultHeaderCell>
                            {render.has_error_perm && <ResultHeaderCell style={{textAlign: 'right', width: 80}}>Perm</ResultHeaderCell>}
                            <ResultHeaderCell style={{textAlign: 'right', width: 80}}>Start Sta</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'right', width: 80}}>End Sta</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'right', width: 80}}>Elev</ResultHeaderCell>
                            {render.has_error_perm && <ResultHeaderCell style={{textAlign: 'right', width: 80}}>Perm</ResultHeaderCell>}
                        </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                        {
                            render.components
                        }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}